import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import {
  Typography, Box, useTheme,
} from '@mui/material'
import { useForm, FormProvider } from "react-hook-form";
import { makeStyles } from '@mui/styles'

import { authActions, workflowActions, fileActions } from '../../store/actions'
import { UseImage, InputField, CustomLoadingOverlay, LinkButton, Alert, Buttons, GenericContainer, GeoLocationGeneric, AlertConfirm } from '../../components'
import { getHash, ClearSession, coreFunctions, obtenerDireccionIP, IPDEFAULT, IsDevice } from '../../utils'
import ConfigurationComponent from '../Configuration/ConfigurationComponent'
import imaBarTop from '../../assets/imaBarTop.png'
import imageWelcome from 'assets/DOC/img/ImageWelcome.png';
import { useTranslation } from 'react-i18next';
import CancelarSolicitud from '../../assets/CancelarSolicitud.png'
import { persistence } from '../../store/persistence';

const useStyles = makeStyles((theme) => ({
  imgTopStyle: {
    [theme.breakpoints.only('md')]: {
      width: '50% !important'
    },
    [theme.breakpoints.only('lg')]: {
      width: '50% !important'
    },
    [theme.breakpoints.only('xl')]: {
      width: '50% !important'
    }
  },
}))

export default function WelcomePortal(props) {
  const theme = useTheme()
  const formMethods = useForm({ mode: "onChange" });
  const { control, handleSubmit, register, formState } = useForm({ mode: "onBlur" });
  const localStyles = useStyles();
  const cancelWF = useSelector(state => state.CancelWorkFlow)

  const [ipCurrent, setIpCurrent] = useState("")
  const [lat, setLat] = useState("12222");
  const [lon, setLon] = useState("22222");
  const [openConfig, setOpenConfig] = useState(false)
  const [cancelAction, setCancelAction] = useState(false)

  const [isAutoconsumo, setIsAutoconsumo] = useState(false)
  const [loadView, setLoadView] = useState(false)
  const [formChange, setFormChange] = useState(false);
  const { t } = useTranslation();

  const navigate = useNavigate()

  //Redux hooks
  const auth = useSelector(state => state.Authentication)
  const wf = useSelector(state => state.Workflow)
  const file = useSelector(state => state.FileInfo)
  const dispatch = useDispatch()

  // useEffect(() => {
  //   if (file.items != undefined) {
  //     console.log("ENTROAQUI 1")
  //     setLoadView(false)
  //     let configs = {
  //       "FileId": file.items.Id,
  //       "OcrOnline": false,
  //       "CaptureSelfieSdk": (sessionStorage.getItem('TypeCaptureSelfieSdk') != undefined && sessionStorage.getItem('TypeCaptureSelfieSdk') != null || sessionStorage.getItem('TypeCaptureSelfieSdk') != "" ? sessionStorage.getItem('TypeCaptureSelfieSdk') : "FaceTec3D"),
  //       "SkipDocumentValidation": (sessionStorage.getItem('omitirValidacion') != undefined && sessionStorage.getItem('omitirValidacion') != null && sessionStorage.getItem('omitirValidacion') != "" ? Boolean(sessionStorage.getItem('omitirValidacion')) : false),
  //       "RiskLevel": (sessionStorage.getItem('nivelRiesgo') != undefined && sessionStorage.getItem('nivelRiesgo') != null || sessionStorage.getItem('nivelRiesgo') != "" ? sessionStorage.getItem('nivelRiesgo') : "Alto")
  //     }
  //     dispatch(fileActions.SetManualConfigurations(configs))
  //     console.log("----file.items----: ", file.items)
  //     if (file.items.Stage?.Roles?.filter(item => item.Name == "Mesa de control")?.length > 0) {
  //       Alert({
  //         icon: "warning",
  //         text: "Se está validando información, intente más tarde.",
  //         okbtntext: "Aceptar",
  //       });
  //     } else {
  //       NextStage(file.items)
  //     }
  //   }
  //   if (file.error != undefined) {
  //     // alert(file.error)
  //     setLoadView(false)
  //     setFormChange(false)
  //     Alert({
  //       icon: "error",
  //       text: file.error,
  //       okbtntext: "Aceptar",
  //     });
  //   }
  // }, [loadView])

  const reenviarWindows = () => {
    if (file.items != undefined) {
      sessionStorage.removeItem('IdUserData')
      sessionStorage.removeItem('UserFullName')
      sessionStorage.removeItem('UserDate')
      sessionStorage.removeItem('FileCodeData')
      sessionStorage.setItem('FlujoUser', file.items.Product)

      console.log("ENTROAQUI 1")
      setLoadView(false)
      let configs = {
        "FileId": file.items.Id,
        "OcrOnline": false,
        "CaptureSelfieSdk": (sessionStorage.getItem('TypeCaptureSelfieSdk') != undefined && sessionStorage.getItem('TypeCaptureSelfieSdk') != null || sessionStorage.getItem('TypeCaptureSelfieSdk') != "" ? sessionStorage.getItem('TypeCaptureSelfieSdk') : "FaceTec3D"),
        "SkipDocumentValidation": (sessionStorage.getItem('omitirValidacion') != undefined && sessionStorage.getItem('omitirValidacion') != null && sessionStorage.getItem('omitirValidacion') != "" ? Boolean(sessionStorage.getItem('omitirValidacion')) : false),
        "RiskLevel": (sessionStorage.getItem('nivelRiesgo') != undefined && sessionStorage.getItem('nivelRiesgo') != null || sessionStorage.getItem('nivelRiesgo') != "" ? sessionStorage.getItem('nivelRiesgo') : "Alto")
      }
      sessionStorage.setItem('FlujoUser', file.items.Product)
      sessionStorage.setItem('IdUserData', file.items.Id)
      sessionStorage.setItem('UserDate', file.items.CreationDateFormatted)
      sessionStorage.setItem('UserFullName', file.items.FullName)
      sessionStorage.setItem('FileCodeData', file.items.Folio)
      dispatch(fileActions.SetManualConfigurations(configs))
      console.log("----file.items----: ", file.items)
      if (file.items.Stage?.Roles?.filter(item => item.Name == "Mesa de control")?.length > 0) {
        Alert({
          icon: "warning",
          text: "Se está validando información, intente más tarde.",
          okbtntext: t("general_accept"),
        });
      } else {
        NextStage(file.items)
      }
    }
    if (file.error != undefined) {
      // alert(file.error)
      setLoadView(false)
      setFormChange(false)
      Alert({
        icon: "error",
        text: file.error,
        okbtntext: t("general_accept"),
      });
    }
  }

  let NextStage = (items) => {
    let nextStage = items.Stage
    let stageName = nextStage.Name
    let stageId = nextStage.Id
    let folioId = items.Id
    let stage = items
    // // console.log("items-Login: ", items)
    let nextComponent = coreFunctions.GetLegoNext(stageName)
    // // console.log("history---------------------", history)
    // let nextComponent = "FirmaEA"
    console.log("Next componenete---------: ", nextComponent)
    coreFunctions.DoNextStage({ navigate, nextComponent, State: { stageName, stageId, stage, folioId } })
  }

  let handleCloseConfig = (event) => {
    // alert("Configuracion")
    setOpenConfig(false)
  }

  //Acción login

  // const validateRedirect = () => {
  //   console.log("....ValidateRedirect......: ", isAutoconsumo, auth.dataModules, auth.items.UserLoginData)
  //   // console.log("wfData..auth.dataModules ....: ", isAutoconsumo, auth.dataModules)
  //   if (!isAutoconsumo && auth.dataModules?.dashboardData?.Name == "Dashboard") {
  //     if (auth.dataModules?.dashboardData?.Name == "Dashboard"
  //       || auth.dataModules?.generarSolicitudesData?.Name == "Generar Solicitudes") {
  //       console.log("....ValidateRedirect.....Paso 1.: ", auth.dataModules, auth.items.UserLoginData)
  //       let nextComponent = "SearchResultComponent"
  //       coreFunctions.DoNextStage({ navigate, nextComponent })
  //     }
  //     else if (auth.dataModules?.busquedaData?.Name == "Busqueda") {
  //       console.log("....ValidateRedirect.....Paso 2.: ", auth.dataModules, auth.items.UserLoginData)
  //       let nextComponent = "SearchResultComponent"
  //       coreFunctions.DoNextStage({ navigate, nextComponent })
  //     } else {
  //       console.log("....ValidateRedirect.....Paso 3.: ", auth.dataModules, auth.items.UserLoginData)
  //       let requestItems = {
  //         Stage: null,
  //         Id: null
  //       }
  //       NextStage(requestItems)
  //     }
  //   } else {
  //     console.log("....ValidateRedirect.....Paso 4.: ", auth.dataModules, auth.items.UserLoginData)
  //     // dispatch(fileActions.GetFileInfo(auth.items.UserLoginData.CurrentFileId))
  //     setLoadView(true)
  //   }
  //   // setFormChange(false)
  // }

  useEffect(() => {
    if (cancelWF.items != undefined && cancelAction) {
      setLoadView(false)
      console.log("cancelWF.items*********************: ", cancelWF.items)
      if (cancelWF.items?.Stage != null) {
        console.log('sacando sesion', cancelWF)
        persistence.EndSession();
        ClearSession();
        navigate("/auth/");

        /* let nextStage = cancelWF.items?.Stage
        let stageName = nextStage.Name
        let stageId = nextStage.Id
        let folioId = file.items.IdWE
        let stage = cancelWF.items?.Stage

        let nextComponent = coreFunctions.GetLegoNext(stageName)
        coreFunctions.DoNextStage({ navigate, nextComponent, State: { stageName, stageId, stage, folioId } }) */
      }
    }
  }, [cancelWF])

  console.log("DATAAUTH", auth, file)

  return (<GenericContainer>
    <FormProvider {...formMethods} theme={theme}>
      {/* <GeoLocationGeneric SuccessFN={(latitude, longitude) => {
        // console.log("succes,latitude, longitude ", latitude, longitude);
        setLat(latitude);
        setLon(longitude);
      }}
        ErrorFN={(error) => console.log('error', error)}
      /> */}

      <Box sx={(theme) => ({
        display: 'flex',
        mt: 13,
        flexDirection: 'column',
        alignContent: 'flex-start',
        alignItems: 'center',
        width: "100%",
        justifyContent: 'center',
        [theme.breakpoints.only('xs')]: {
          padding: "3px 2em",
          height: '50vh',
        },
        [theme.breakpoints.only('sm')]: {
          padding: "3px 0.5em",
          height: '50vh',
        },
        [theme.breakpoints.only('md')]: {
          padding: "5px 7em",
          height: '50vh',
        },
        [theme.breakpoints.only('lg')]: {
          padding: "6px 6em",
          height: '50vh',
        },
        [theme.breakpoints.only('xl')]: {
          padding: "8px 8em",
          height: '40vh',
        },
      })}>
        {loadView ? <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} /> : null}

        <Box sx={(theme) => ({
          display: 'flex',
          width: "100%",
          height: '50vh'
        })}>
          <Typography variant="h4" gutterBottom >{`${t("welcome_message")} `}<spam style={{ color: theme.palette.primary.main }}>{file.items?.FullName} </spam>!</Typography>
        </Box>
        {console.log('fileItems', file.items)}
        <Box sx={{ display: 'fllex', justifyContent: 'center', alignItems: 'center', mb: 2 }}>
          {file.items?.Status == "Finalizado Rechazado" || file.items?.Status == "Finalizado Cancelado" ? (
            <UseImage src={CancelarSolicitud}
              width={'95%'}
            />
          ) : (
            <UseImage src={imageWelcome}
              width={'80%'}
            />
          )}

        </Box>

        <Box sx={{ width: "100%", justifyContent: 'left', alignItems: 'center', mb: 2 }}>
          <Box>
            <Typography
              textAlign={"justify"}
              variant="subtitle"
            >
              <b>{`${t("general_folio")}: `}</b> {file?.items?.Folio}
            </Typography>
          </Box>
          <Box>
            <Typography
              textAlign={"justify"}
              variant="subtitle"
            >
              <b>{`${t("general_date")}: `}</b> {file?.items?.CreationDateFormatted}
            </Typography>
          </Box>
        </Box>
        <Box>
          <Typography variant="h4" >
            {auth?.items?.UserLoginData?.Username != file?.items?.CurrentUser ? t("procedure_in_process") : null}
          </Typography>
        </Box>
        {file.items?.Status == "Finalizado Rechazado" || file.items?.Status == "Finalizado Cancelado" ? (
          <Box>
            <Typography variant='h5'>
              {t("procedure_cancelled")}
            </Typography>
            <Buttons
              onClickConfirm={() => {
                persistence.EndSession();
                ClearSession();
                navigate("/auth/");
              }}
              ConfirmButtonText="Finalizar"
            />
          </Box>
        ) : (
          <Buttons
            onClickConfirm={() => reenviarWindows()}
            disabledConfirm={auth.items?.UserLoginData?.Username != file?.items?.CurrentUser}
            /* CancelButtonText="Cancelar"
            onClickCancel={() => {
              AlertConfirm(
                {
                  icon: "warning",
                  html: <Box>
                    <Typography
                      textAlign={"center"}
                      variant="body1"
                      sx={{ mt: 1, textAlign: "center", maxWidth: 400, mx: "auto" }}
                    >
                      <b>¿Estás seguro de cancelar el proceso?</b>
                    </Typography>
                    <br />
                    <Typography
                      textAlign={"center"}
                      variant="body1"
                      sx={{ mt: 1, textAlign: "center", maxWidth: 400, mx: "auto" }}
                    >
                      Una vez cancelado, su proceso de contratación quedará cancelado
                    </Typography>
                  </Box>,
                  okbtntext: "Si, cancelar",
                  notbtntext: "No, continuar proceso",
                },
                (result) => {
                  if (result.isConfirmed) {
                    setCancelAction(true)
                    setLoadView(true)
                    dispatch(workflowActions.CancelWorkFlow({ File_Id: file.items.Id }))
                  } else if (result.dismiss === "cancel" && result.isDismissed) {
                    // setCancelAlert(false)
                  }
                }
              );
            }
            } */
          />
        )}

      </Box>
      <ConfigurationComponent open={openConfig} close={handleCloseConfig} />
    </FormProvider >
  </GenericContainer>)
}